module.exports = __webpack_public_path__ + "img/ribbon-back.b8b9c229.png";